<template>
  <td class="r">{{ amounts.buy == null ? '-' : CurrencyHelper.currency(amounts.buy) }}</td>
  <td class="r">{{ amounts.sell == null ? '-' : CurrencyHelper.currency(amounts.sell) }}</td>
  <td class="r" :class="{ 'vcr-negative': amounts.margin < 0 }">
    {{ CurrencyHelper.margin(amounts.margin) }}
  </td>
  <td class="r">
    <vcr-margin-percentage :percentage="amounts.pct" />
  </td>
</template>

<script>
import CurrencyHelper from '@/helpers/currencyHelper'
import VcrMarginPercentage from './VcrMarginPercentage.vue'

export default {
  components: { VcrMarginPercentage },
  props: {
    amounts: { type: Object, required: true },
  },
  data() {
    return { CurrencyHelper }
  },
}
</script>
